module.exports = __webpack_public_path__ + "static/media/teche.666ee949.PNG";